export const whatsNewItems = [
  { title: 'Professional Websites, Hosting & Digital Marketing — in partnership with Arina Technologies', href: '/digital-marketing' },
] as const
